import { render, staticRenderFns } from "./ShortcutSettingModal.vue?vue&type=template&id=3830941a&scoped=true"
import script from "./ShortcutSettingModal.ts?vue&type=script&lang=ts&external"
export * from "./ShortcutSettingModal.ts?vue&type=script&lang=ts&external"
import style0 from "./ShortcutSettingModal.vue?vue&type=style&index=0&id=3830941a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3830941a",
  null
  
)

export default component.exports